import {
  IApiKey,
  ICreateApiKeyRequest,
  IEditUserPasswordRequest,
  IEditUserRequest,
  IMcpConnection,
  INewApiKey,
  IUserApi,
} from '@/api/user/user.types';
import { ApiEndpoints } from '@/types/routes';
import { IHttpClient } from '@/api/HttpClient';
import { IUserDto } from '@/types/user';

export class UserApi implements IUserApi {
  private getBaseUrl(): string {
    return ApiEndpoints.USER;
  }

  constructor(private readonly httpClient: IHttpClient) {}

  getUser(token: string, id: string) {
    return this.httpClient.get<IUserDto>(`${this.getBaseUrl()}/${id}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  }

  getUserById(id: string) {
    return this.httpClient.get<IUserDto>(`${this.getBaseUrl()}/${id}/`);
  }

  editUser({ id, ...payload }: IEditUserRequest) {
    return this.httpClient.patch<Partial<IEditUserRequest>, IUserDto>(
      `${this.getBaseUrl()}/${id}/`,
      payload,
    );
  }

  editUserPassword({ id, ...payload }: IEditUserPasswordRequest) {
    return this.httpClient.patch<Partial<IEditUserPasswordRequest>, IUserDto>(
      `${this.getBaseUrl()}/${id}/update_password/`,
      payload,
    );
  }

  createApiKey({ name }: ICreateApiKeyRequest) {
    const params = {
      name,
    };

    return this.httpClient.post<Partial<ICreateApiKeyRequest>, INewApiKey>(
      `${this.getBaseUrl()}/api_key`,
      params,
    );
  }

  getApiKey() {
    return this.httpClient.get<IApiKey[]>(`${this.getBaseUrl()}/api_key`);
  }

  deleteApiKey(keyId: string) {
    return this.httpClient.delete<void>(`${this.getBaseUrl()}/api_key/${keyId}`);
  }

  getMcpConnections() {
    return this.httpClient.get<IMcpConnection[]>(`${this.getBaseUrl()}/mcp_connection`);
  }

  deleteMcpConnection(connectionId: string) {
    return this.httpClient.delete<void>(`${this.getBaseUrl()}/mcp_connection/${connectionId}`);
  }
}
